import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Header from "./Header";
import Footer from "../Footer";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../App.css";
import fire from "./Firebase";
import {
 
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBRow,
  MDBCol,
 
  MDBInput,
} from "mdb-react-ui-kit";

function Login() {
  // localStorage.setItem(
  //   "login",
  //   JSON.stringify({ password: "herogaur", Email: "herogaur@gmail.com" })
  // );
  document.title = "HR School - Login";
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  // const navigate = useNavigate();
  // const userName = localStorage.getItem("email")
  //   ? localStorage.getItem("email")
  //   : "herogaur@gmail.com";
  // const userPassword = localStorage.getItem("email")
  //   ? localStorage.getItem("password")
  //   : "herogaur";

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (email === userName && password === userPassword) {
  //     toast.success("Welcome to Admin Page");
  //     setTimeout(() => {
  //       navigate("/admin");
  //     }, 200);
  //   } else {
  //     toast.error("Invalid Email Or Password");
  //   }
  // };
  const navigate = useNavigate();
  const [logindata, setlogindata] = useState("");
  const [logindata1, setlogindata1] = useState({});
  const [logindata2, setlogindata2] = useState([]);

  useEffect(() => {
    fire.child("login").on("value", (data) => {
      if (data.val() == null || data.val() == "") {
        toast.error("Data Not Fatch");
      } else {
        setlogindata1(data.val());
        console.log(data.val());
      }
    });
  }, []);
  useEffect(() => {
    Object.keys(logindata1).map((newlogin) => {
      console.log(logindata1[newlogin]);
      setlogindata2(logindata1[newlogin]);
      
    });
  }, [logindata1]);

  function all(e) {
    setlogindata({ ...logindata, [e.target.name]: e.target.value });
  }
  function handleSubmit() {
    // fire.child("login").push(logindata);
    if (
      logindata.email == logindata2.email &&
      logindata2.password == logindata.password
    ) {
      console.log(logindata2.email);
      console.log(logindata.email);
      toast.success("welcome");
      navigate("/admin")
    } else {
      toast.error("Wrong Email and Password");
    }
  }

  return (
    <>
      <Header />
      <div className="login">
        <br />
        <MDBContainer className="my-5">
          <MDBCard>
            <MDBRow className="g-0">
              <MDBCol md="6">
                <MDBCardImage
                  src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/img1.webp"
                  alt="login form"
                  className="rounded-start w-100"
                />
              </MDBCol>

              <MDBCol md="6">
                <MDBCardBody className="d-flex flex-column">
                  <h5
                    className="fw-normal my-4 pb-3"
                    style={{ letterSpacing: "1px" }}
                  >
                    Sign into your account
                  </h5>
                  <MDBInput
                    wrapperClass="mb-6"
                    // label="Email address"
                    placeholder="Enter Email"
                    id="formControlLg"
                    type="email"
                    name="email"
                    onChange={all}
                    size="lg"
                  />{" "}
                  <br />
                  <MDBInput
                    name="password"
                    wrapperClass="mb-4"
                    // label="Password"
                    placeholder="Enter Password"
                    onChange={all}
                    id="formControlLg"
                    type="password"
                    size="lg"
                  />{" "}
                  <br />
                
                  {/* <MDBBtn
                    className="mb-4 px-5"
                    color="dark"
                    size="lg"
                    onClick={handleSubmit}
                  >
                    Login
                  </MDBBtn> */}
                  <button
                    className="loginbtn"
                    color="dark"
                    size="lg"
                    onClick={handleSubmit}
                  >
                    Login
                  </button>
                  <a className="small text-muted" href="#!">
                    Forgot password?
                  </a>
                  <div className="d-flex flex-row justify-content-start">
                    <Link to="#!" className="small text-muted me-1">
                      Terms of use.
                    </Link>
                    <a href="#!" className="small text-muted">
                      Privacy policy
                    </a>
                  </div>
                </MDBCardBody>
              </MDBCol>
            </MDBRow>
          </MDBCard>
        </MDBContainer>
      </div>
      <Footer />
    </>
  );
}

export default Login;
